import { TemplateRef } from '@angular/core';

import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../../base/store/actions';
import { BetBuilderV1EventData, PickAddPayload } from '../../../core/external-betslip-actions';
import { BetBuilderPickId } from '../../../core/picks/pick-id';
import { IPickTracking } from '../../../core/picks/pick-models';
import { IAffiliateLink, IAffiliateLinkRequest } from '../affiliate.model';

export default class AffiliateActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/affiliate`;

    private static readonly GENERATE_AFFILIATE_LINK = `${AffiliateActions.ACTION_SCHEMA}/GENERATE_AFFILIATE_LINK`;
    private static readonly SET_AFFILIATE_LINK = `${AffiliateActions.ACTION_SCHEMA}/SET_AFFILIATE_LINK`;
    private static readonly ADD_AFFILIATE_PICK = `${AffiliateActions.ACTION_SCHEMA}/ADD_AFFILIATE_PICK`;
    private static readonly ADD_AFFILIATE_GROUP_PICK = `${AffiliateActions.ACTION_SCHEMA}/ADD_AFFILIATE_GROUP_PICK`;
    private static readonly ADD_AFFILIATE_BETBUILDER_PICK = `${AffiliateActions.ACTION_SCHEMA}/ADD_AFFILIATE_BETBUILDER_PICK`;
    private static readonly OPEN_BETSLIP = `${AffiliateActions.ACTION_SCHEMA}/OPEN_BETSLIP`;
    private static readonly RESET_AFFILIATE_LINK = `${AffiliateActions.ACTION_SCHEMA}/RESET_AFFILIATE_LINK`;
    private static readonly ALL_PICKS_FAILED = `${AffiliateActions.ACTION_SCHEMA}/ALL_PICKS_FAILED`;

    /**
     * called to generate affiliate deep link (by affiliate helper)
     */
    static generateAffiliateLink = createAction(AffiliateActions.GENERATE_AFFILIATE_LINK, props<{ payload: IAffiliateLinkRequest }>());

    /**
     * set generated affiliate link (from affiliate helper)
     */
    static setAffiliateLink = createAction(AffiliateActions.SET_AFFILIATE_LINK, props<{ link: IAffiliateLink }>());

    /**
     * add affiliate v1/v2 pick to betslip
     */
    static addAffiliatePick = createAction(AffiliateActions.ADD_AFFILIATE_PICK, props<{ payload: PickAddPayload }>());

    /**
     * add group affiliate v1/v2 pick to betslip
     */
    static addAffiliateGroupPick = createAction(
        AffiliateActions.ADD_AFFILIATE_GROUP_PICK,
        props<{ picks: PickAddPayload[]; headerTemplate?: TemplateRef<any> }>(),
    );

    /**
     * add affiliate bet builder pick to betslip
     */
    static addAffiliateBetBuilderPick = createAction(
        AffiliateActions.ADD_AFFILIATE_BETBUILDER_PICK,
        props<{ pickId: BetBuilderPickId; tracking: IPickTracking; eventData: BetBuilderV1EventData | null }>(),
    );

    /**
     * mark betslip as opened (should be opened only once, for first successful affiliate pick added to betslip)
     */
    static openBetslip = createAction(AffiliateActions.OPEN_BETSLIP);

    /**
     * reset affiliate state (to default state)
     */
    static resetAffiliateState = createAction(AffiliateActions.RESET_AFFILIATE_LINK);

    /**
     * handle final clean-up, if no picks could be processed
     */
    static allPicksFailed = createAction(AffiliateActions.ALL_PICKS_FAILED);
}
